export const FinishIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M1.5 0.5V15.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.5 2.5H14.5V10.5H3.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.5 6.5H14.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2.5V10.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.5 2.5V10.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
